<template>
    <!-- Modal Activity Empty -->
    <div class="modal fade" id="modalIsEmpty" tabindex="-1" role="dialog" aria-labelledby="modalAdultoCenter" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Em breve!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">            
            Nenhuma loja disponível neste segmento!
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Voltar</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "EmptyModal"
  }
</script>
